import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { WorkOrderService } from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditWorkOrder.html",
})
export class AddEditWorkOrder {
  row: any;
  data: any;
  designdata: any = {};
  wodata: any = {
    shirt_design_no: "",
    party_code: "",
    party_name: "",
    totalrate: 0,
    fullrate: 0,
    halfrate: 0,
    f36_ratio: 0,
    f38_ratio: 0,
    f40_ratio: 0,
    f42_ratio: 0,
    f44_ratio: 0,
    f46_ratio: 0,
    h36_ratio: 0,
    h38_ratio: 0,
    h40_ratio: 0,
    h42_ratio: 0,
    h44_ratio: 0,
    h46_ratio: 0,
    tot_full_ratio: 0,
    tot_half_ratio: 0,
  };
  qualityList: any;
  typeList: any;
  colorList: any;
  fabtype: any;
  codeList: any;
  stockdata: any[];
  matchstockdata: any[];

  widthList: any[];
  multiFablist = [];
  multiFablist1 = [];
  designnoList: any[];
  tempColor = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  shadeList: any;
  matchList: any;
  matchDesList = [];
  matchColorList: any;
  matchDesColorList = [];
  matchConsList: any;
  matchDesConsList = [];
  designList = [
    {
      design_no: "",
      shade: "",
      color: "",
      meter: 0,
      mtr: 0,
      fs_tot_cons: 0,
      hs_tot_cons: 0,
      fs_tot_pcs: 0,
      hs_tot_pcs: 0,
      ftot: 0,
      htot: 0,
      fbalmtrs: 0,
      hbalmtrs: 0,
      totmtrs: 0,
    },
  ];
  match_designList = [{
    match_des_no: "",
    match_des_color: "",
    match_avl_mtrs: 0,
    match_cons: 0,
    match_need_mtrs: 0
  }]
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.wodata = designdata;
    if (this.mode == "Edit" || this.mode == "Cancel") {
      this.calcFullCons();
      //this.wodata.wo_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      // this.getpartyname(this.wodata.party_code);
      this.getDesignList(this.wodata.wo_id);
      this.onEnterShirtNo(this.wodata.shirt_design_no);
    } else if (this.mode == "View") {
      this.wodata = designdata;
      this.wodata.wo_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.calcFullCons();
      this.getDesignList1(this.wodata.wo_id);
      // this.wodata.shirt_design_no = this.wodata.shirtdno
      this.onEnterShirtNo(this.wodata.shirt_design_no);
      //   this.getpartyname(this.wodata.party_code);
      //  this.getDesignList(this.wodata.wo_id);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private woservice: WorkOrderService
  ) { }
  ngOnInit() {
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "view") {
      this.wodata.wo_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      // this.wodata.party_code = 'UNIT 1';
      if (this.mode == "Add") {
        this.wodata.f36_ratio = 0;
        (this.wodata.f38_ratio = 0),
          (this.wodata.f40_ratio = 0),
          (this.wodata.f42_ratio = 0),
          (this.wodata.f44_ratio = 0),
          (this.wodata.f46_ratio = 0),
          (this.wodata.h36_ratio = 0),
          (this.wodata.h38_ratio = 0),
          (this.wodata.h40_ratio = 0),
          (this.wodata.h42_ratio = 0),
          (this.wodata.h44_ratio = 0),
          (this.wodata.h46_ratio = 0),
          (this.wodata.tot_full_ratio = 0),
          (this.wodata.tot_half_ratio = 0);
        // this.getpartyname(this.wodata.party_code);
        //  this.getAuto();
        //  this.getWoAuto();

        this.getShirtDesign();
      }
    }
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#shirtno").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "f36-1") {
      $("#" + nextEl).select();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToMatchNextFld($event, fld, ind) {
    let nxtInd = ind;
    if (fld == 'addrow') {
      // console.log(fld, ind)
      this.match_designList.push({
        match_des_no: "",
        match_des_color: "",
        match_avl_mtrs: 0,
        match_cons: 0,
        match_need_mtrs: 0
      });
    }
    else {
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      meter = this.designList[ind]["meter"],
      fper = this.designList[ind]["fper"],
      hper = this.designList[ind]["hper"],
      /*  f36 = this.designList[ind].f36,
            f38 = this.designList[ind].f38,
            f40 = this.designList[ind].f40,
            f42 = this.designList[ind].f42,
            f44 = this.designList[ind].f44,
            h36 = this.designList[ind].h36,
            h38 = this.designList[ind].h38,
            h40 = this.designList[ind].h40,
            h42 = this.designList[ind].h42,
            h44 = this.designList[ind].h44, */
      balmtrs = this.designList[ind].fbalmtrs,
      totmtrs = this.designList[ind]["totmtrs"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.designList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "shade" && nxtRow.length == 0) {
      let len = this.designList.length;
      let shade = this.designList[len - 1]["shade"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.designList.push({
          design_no: "",
          shade: "",
          color: "",
          meter: 0,
          fs_tot_cons: 0,
          hs_tot_cons: 0,
          fs_tot_pcs: 0,
          hs_tot_pcs: 0,

          ftot: 0,
          mtr: 0,
          htot: 0,
          fbalmtrs: 0,
          hbalmtrs: 0,
          totmtrs: 0,
        });

        $("#" + "shade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
      /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
              fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
              $('#'  + fld + '-' + nxtInd).select();
             
          }else if(fld=="f36"){
              nxtInd = nxtInd +1;
               $('#'  + fld + '-' + nxtInd).select();
          }
          else if (fld == "item_name") {
              let nxtRowID = nxtRow[0].id;
              nxtInd = nxtRowID.split("-")[1];
          } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  /*   calcTotal($event,ind){
        let item = this.designList[ind];
       
        let totalmtrs = item.f36+ item.f38 + item.f40 + item.f42 +item.f44
         + item.h36 + item.h38 + item.h40 + item.h42 + item.h44;
        this.designList[ind]['ftot'] =  item.f36+ item.f38 + item.f40 + item.f42 +item.f44;
        this.designList[ind]['htot'] = item.h36 + item.h38 + item.h40 + item.h42 + item.h44;
        let mtrs = item.meter;
        this.designList[ind].fbalmtrs = mtrs -(this.designList[ind]['ftot']*this.wodata.fcons + this.designList[ind]['htot']*this.wodata.hcons) ;
        this.designList[ind].hbalmtrs =  parseFloat(this.designList[ind].fbalmtrs.toFixed(3));
        this.designList[ind].totmtrs = parseFloat(totalmtrs.toFixed(3));
        
        if(this.mode=='Add'){
            this.calcRate();
        }else{
            this.calctotalRate();
        }

    }

    calcRate(){
        let item = this.designList;

        let fullrate = 0,halfrate=0,totalrate=0;
        for(let i=1;i<item.length;i++){
           fullrate += item[i].f36+ item[i].f38 + item[i].f40 + item[i].f42 +item[i].f44;
           halfrate += item[i].h36+ item[i].h38 + item[i].h40 + item[i].h42 +item[i].h44;
           totalrate = fullrate + halfrate;
        }

        this.wodata.fullrate = fullrate;
        this.wodata.halfrate = halfrate;
        this.wodata.totalrate = totalrate;
    }

    calctotalRate(){
        let item = this.designList;

        let fullrate = 0,halfrate=0,totalrate=0;
        for(let i=0;i<item.length;i++){
           fullrate += item[i].f36+ item[i].f38 + item[i].f40 + item[i].f42 +item[i].f44;
           halfrate += item[i].h36+ item[i].h38 + item[i].h40 + item[i].h42 +item[i].h44;
           totalrate = fullrate + halfrate;
        }

        this.wodata.fullrate = fullrate;
        this.wodata.halfrate = halfrate;
        this.wodata.totalrate = totalrate;
    }

    getpartyname(code){

        let params = {
            code: code
        };
        this.woservice
            .getPartyDet(params)
            .then((res: any) => {

                this.wodata.party_name = res.data[0].party_name;
                this.wodata.party_id = res.data[0].party_id;
                
            });

    }*/
  getShirtDesign() {
    let params = {};
    let that = this;
    this.woservice.getShirtDesign(params).then(function (res: any) {
      that.designnoList = res;
    });
  }
  getDesignList(wo_id) {
    let params = {
      wo_id: wo_id,
    };
    if (this.mode == "Cancel") {
      params["mode"] = this.mode;
    }
    this.woservice.getEditDesignList(params).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        this.designList[i] = res.data[i];
        this.designList[i].color = res.data[i].color;
        //this.calcTotal('$event',i);
      }
      for (let i = 0; i < res.match.length; i++) {
        this.match_designList[i] = res.match[i];
        // this.match_designList[i].match_avl_mtrs = res.match[i].match_avl_mtrs;
        //this.calcTotal('$event',i);
      }
    });

  }
  selectfabcolor(type) {
    let temp = this.multiFablist1.filter((o) => o.fab_no == type);


    this.shadeList = temp;
  }
  getDesignList1(wo_id) {
    let params = {
      wo_id: wo_id,
    };
    this.woservice.getEditDesignList(params).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        this.designList[i] = res.data[i];
        this.designList[i].color = res.data[i].color;
        //this.calcTotal('$event',i);
      }
    });

  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  calcFullCons() {
    //totalfullratio
    this.wodata.tot_full_ratio = (
      this.wodata.f36_ratio +
      this.wodata.f38_ratio +
      this.wodata.f40_ratio +
      this.wodata.f42_ratio +
      this.wodata.f44_ratio +
      this.wodata.f46_ratio
    ).toFixed(2);
    //First half formula calculation for full sleeve
    this.wodata.f36_calc = (
      (this.wodata.f36_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f38_calc = (
      (this.wodata.f38_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f40_calc = (
      (this.wodata.f40_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f42_calc = (
      (this.wodata.f42_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f44_calc = (
      (this.wodata.f44_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f46_calc = (
      (this.wodata.f46_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    //totalhalfratio
    this.wodata.tot_half_ratio = (
      this.wodata.h36_ratio +
      this.wodata.h38_ratio +
      this.wodata.h40_ratio +
      this.wodata.h42_ratio +
      this.wodata.h44_ratio +
      this.wodata.h46_ratio
    ).toFixed(2);
    //First half formula calculation for half sleeve
    this.wodata.h36_calc =
      this.wodata.tot_half_ratio && this.wodata.h36_ratio
        ? ((this.wodata.h36_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h38_calc =
      this.wodata.tot_half_ratio && this.wodata.h38_ratio
        ? ((this.wodata.h38_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h40_calc =
      this.wodata.tot_half_ratio && this.wodata.h40_ratio
        ? ((this.wodata.h40_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h42_calc =
      this.wodata.tot_half_ratio && this.wodata.h42_ratio
        ? ((this.wodata.h42_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h44_calc =
      this.wodata.tot_half_ratio && this.wodata.h44_ratio
        ? ((this.wodata.h44_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h46_calc =
      this.wodata.tot_half_ratio && this.wodata.h46_ratio
        ? ((this.wodata.h46_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    //total of first half formulat values
    this.wodata.tot_full_calc = Math.round(
      parseFloat(this.wodata.f36_calc) +
      parseFloat(this.wodata.f38_calc) +
      parseFloat(this.wodata.f40_calc) +
      parseFloat(this.wodata.f42_calc) +
      parseFloat(this.wodata.f44_calc) +
      parseFloat(this.wodata.f46_calc)
    ).toFixed(2);
    this.wodata.tot_half_calc = Math.round(
      parseFloat(this.wodata.h36_calc) +
      parseFloat(this.wodata.h38_calc) +
      parseFloat(this.wodata.h40_calc) +
      parseFloat(this.wodata.h42_calc) +
      parseFloat(this.wodata.h44_calc) +
      parseFloat(this.wodata.h46_calc)
    ).toFixed(2);
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);

          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
        that.calcTotal();
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  getAuto() {
    this.designList.forEach((arr) => {
      if (arr.mtr == 0 || arr.mtr == undefined) {
        swal("Make Sure that meter values are valid");
        return false;
      } else {
        if (this.mode == "Add") {
          this.woservice.getAuto({}).then((res: any) => {
            this.wodata.ref_no = res;
            this.getWoAuto();
          });
        } else {
          this.oncheckemptyrow();
        }
      }
    });
  }
  returnWo() {
    //  this.designList.forEach(arr => {
    // if(arr.mtr==0 || arr.mtr==undefined ){
    //     swal("Make Sure that meter values are valid");
    //     return false
    // }

    //  else{

    this.woservice.returnWo({}).then((res: any) => {
      this.wodata.ref_no = res;
      this.getWoAuto();
    });
    this.oncheckemptyrow();

    //  }
    //  })
  }
  calcLimit(data, shade) {
    let totMtrs = 0;
    let totStock = 0;
    data.forEach((element) => {
      totMtrs += parseFloat(element.avl_mtrs);
    });
    this.designList.forEach((elm) => {
      if (elm.shade == shade) {
        totStock += Number(elm.mtr);
      }
    });
    if (totMtrs < Number(totStock)) {
      swal(" Meters value greater than Stock for shade " + shade);
      this.designList.forEach((val) => {
        if (val.shade == shade) {
          val.mtr = 0;
        }
      });
    }
  }
  getWoAuto() {
    this.woservice.getWoAuto({}).then((res: any) => {
      this.wodata.wo_no = res;
      this.oncheckemptyrow();
    });
  }
  clearWorkorder() {
    this.designList = [
      {
        design_no: "",
        shade: "",
        color: "",
        meter: 0,
        fs_tot_cons: 0,
        hs_tot_cons: 0,
        fs_tot_pcs: 0,
        hs_tot_pcs: 0,
        ftot: 0,
        htot: 0,
        fbalmtrs: 0,
        hbalmtrs: 0,
        totmtrs: 0,
        mtr: 0,
      },
    ];
  }
  onEnterShirtNo(shirtdno) {
    this.matchDesList = [];
    this.matchDesColorList = [];
    let params = {
      shirtdno: shirtdno,
    };
    
    let that = this;
    that.woservice.getDesignDetailsList(params).then((res: any) => {
      if (res.totCnt > 0 && res.fabtype == "singlefab") {
        that.wodata.brand = res.data.brand;
        that.wodata.variety = res.data.variety;
        that.wodata.style = res.data.style;
        that.wodata.sample_no = res.data.sample_no;
        that.wodata.fab_design = res.data.fab_design_no;
        that.wodata.wo_full_cons = res.data.wo_full_cons;
        that.wodata.wo_half_cons = res.data.wo_half_cons;
        that.wodata["samp_id"] = res.data.samp_id;
        that.fabtype = res.fabtype;
        that.matchList = res.match;
        that.matchList.forEach((e) => {
          for (let x in e) {
            if (e[x])
              that.matchDesList.push(e[x]);
          }
        });
        that.matchColorList = res.colorList;
        that.matchColorList.forEach((e) => {
          for (let x in e) {
            if (e[x])
              that.matchDesColorList.push(e[x]);
          }
        });
        that.matchConsList = res.consList;
        that.matchConsList.forEach((e) => {
          for (let x in e) {
            if (e[x])
              that.matchDesConsList.push(e[x]);
          }
        });
        that.shadeList = res.shade;

      }
      else if (res.totCnt > 0 && res.fabtype == "Multifab") {
        that.wodata.brand = res.data[0].brand;
        that.wodata.style = res.data[0].style;
        that.wodata.variety = res.data[0].variety;
        that.wodata.sample_no = res.data[0].sample_no;
        that.wodata.wo_full_cons = res.data[0].full_cons;
        that.wodata.wo_half_cons = res.data[0].half_cons;
        that.wodata["samp_id"] = res.data[0].samp_id;
        let unique = [];
        that.fabtype = res.fabtype;
        that.matchList = res.match;
        // that.matchList.forEach((e) => {
        //   for (let x in e) {
        //     if (e[x])
        //       that.matchDesList.push(e[x]);
        //   }
        // });
        that.matchColorList = res.colorList;
        that.matchColorList.forEach((e) => {
          for (let x in e) {
            if (e[x])
              that.matchDesColorList.push(e[x]);
          }
        });
        that.matchConsList = res.consList;
        that.matchConsList.forEach((e) => {
          for (let x in e) {
            if (e[x])
              that.matchDesConsList.push(e[x]);
          }
        });
        that.shadeList = res.shade;

        // if(res.shade.length == 0 || !res.shade[0].shade){
        //   swal(res.data[0].shirt_no +" "+"Does Not Have Any Shade!"); 
        //   return
        // }
        unique = res.data;
        that.multiFablist1 = res.data;

        that.multiFablist = unique.map(item => item.fab_no)
          .filter((value, index, self) => self.indexOf(value) === index)

        // Only one fabric mapped, so there is nothing to choose - prefill it.
        // With several, the user picks from the fab No autocomplete.
        if (that.multiFablist.length == 1) {
          that.wodata.fab_design = that.multiFablist[0];
        }

        if (that.mode == "View") {


          for (let i = 0; i < that.designList.length; i++) {
            that.shadeList[i] = that.designList[i];


          }

        }



      }
      else {
        this.wodata.brand = "";
        this.wodata.style = "";
        this.wodata.sample_no = "";
        this.wodata.shirtmfdno = "";
        this.wodata.variety = "";
        this.wodata.fab_design = "";
        this.wodata.wo_full_cons = "";
        this.wodata.wo_half_cons = "";
        this.wodata.fcons = "";
        this.wodata.hcons = "";
        this.designList = [
          {
            design_no: "",
            shade: "",
            color: "",
            meter: 0,
            fs_tot_cons: 0,
            hs_tot_cons: 0,
            fs_tot_pcs: 0,
            hs_tot_pcs: 0,
            /*   f36: 0,
                        f38: 0,
                        f40: 0,
                        f42: 0,
                        f44: 0,
                        f46:0, */
            ftot: 0,
            mtr: 0,
            /*   h36: 0,
                        h38: 0,
                        h40: 0,
                        h42: 0,
                        h44: 0,
                        h46:0, */
            htot: 0,
            fbalmtrs: 0,
            hbalmtrs: 0,
            totmtrs: 0,
          },
        ];
      }
    });
  }

  onSelectShade(shade, ind) {
    let color = this.shadeList.filter((o) => o.shade == shade)
    this.designList[ind].color = color[0].color;
    this.stockdata = [];
    let params = {
      fab_design_no: this.wodata.fab_design,
      shirt_design_no: this.wodata.shirt_design_no,
      color: shade,
      fab_type: this.fabtype

    };
    let that = this;
    that.woservice.getStock(params).then((res: any) => {
      if (res.data.length > 0) {
        this.stockdata = res.data;
      } else {
        this.designList[ind]["mtr"] = 0;
        this.designList[ind]["fs_tot_cons"] = 0;
        this.designList[ind]["hs_tot_cons"] = 0;
        this.designList[ind]["fs_tot_pcs"] = 0;
        this.designList[ind]["hs_tot_pcs"] = 0;
        this.designList[ind]["f36"] = 0;
        this.designList[ind]["f38"] = 0;
        this.designList[ind]["f40"] = 0;
        this.designList[ind]["f42"] = 0;
        this.designList[ind]["f44"] = 0;
        this.designList[ind]["f46"] = 0;
        this.designList[ind]["h36"] = 0;
        this.designList[ind]["h38"] = 0;
        this.designList[ind]["h40"] = 0;
        this.designList[ind]["h42"] = 0;
        this.designList[ind]["h44"] = 0;
        this.designList[ind]["h46"] = 0;
        this.calcBalMtrs(ind);
      }
      // this.designList[ind]['mtr']=this.stockdata[0]['avl_mtrs'];
      // this.woCalc(ind);
    });
  }
  onSelectMatch(ind) {
     this.matchstockdata = [];
    let params = {
      design: this.match_designList[ind].match_des_no,
      color: this.match_designList[ind].match_des_color
    }

    let that = this;
    that.woservice.getmatchStock(params).then((res: any) => {
      if (res.data.length > 0) {
        that.matchstockdata = res.data;
      }
    });
  }
  onSelectMtrs(ind){
  let mtr:any = 0;
     mtr = ((this.wodata.tot_pcs)*(this.match_designList[ind].match_cons)).toFixed(2);
     this.match_designList[ind].match_need_mtrs = mtr;
  }
  CalcMatchMtr(ind){
    console.log(ind,this.match_designList)
  }
  woCalc(ind) {
    this.designList[ind]["fs_tot_cons"] =
      (this.designList[ind]["mtr"] * this.wodata.fsratio) / 100;
    this.designList[ind]["hs_tot_cons"] =
      (this.designList[ind]["mtr"] * this.wodata.hsratio) / 100;
    this.designList[ind]["fs_tot_pcs"] = Math.round(
      this.designList[ind]["fs_tot_cons"] / this.wodata.wo_full_cons
    );
    this.designList[ind]["hs_tot_pcs"] = Math.round(
      this.designList[ind]["hs_tot_cons"] / this.wodata.wo_half_cons
    );
    this.designList[ind]["f36"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f36_calc) / 100
    );
    this.designList[ind]["f38"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f38_calc) / 100
    );
    this.designList[ind]["f40"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f40_calc) / 100
    );
    this.designList[ind]["f42"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f42_calc) / 100
    );
    this.designList[ind]["f44"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f44_calc) / 100
    );
    this.designList[ind]["f46"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f46_calc) / 100
    );

    this.designList[ind]["h36"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h36_calc) / 100
    );
    this.designList[ind]["h38"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h38_calc) / 100
    );
    this.designList[ind]["h40"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h40_calc) / 100
    );
    this.designList[ind]["h42"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h42_calc) / 100
    );
    this.designList[ind]["h44"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h44_calc) / 100
    );
    this.designList[ind]["h46"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h46_calc) / 100
    );
    this.designList[ind]['cloth_color'] = this.stockdata[0]['cloth_color'];
    this.calcBalMtrs(ind);
  }
  calcBalMtrs(ind) {
    console.log(this.designList[ind]);
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    //ftotalpcs
    this.designList[ind]["ftot"] =
      nan(this.designList[ind]["f36"]) +
      nan(this.designList[ind]["f38"]) +
      nan(this.designList[ind]["f40"]) +
      nan(this.designList[ind]["f42"]) +
      nan(this.designList[ind]["f44"]) +
      nan(this.designList[ind]["f46"]);

    //htotalpcs
    this.designList[ind]["htot"] =
      nan(this.designList[ind]["h36"]) +
      nan(this.designList[ind]["h38"]) +
      nan(this.designList[ind]["h40"]) +
      nan(this.designList[ind]["h42"]) +
      nan(this.designList[ind]["h44"]) +
      nan(this.designList[ind]["h46"]);

    //balance meters
    this.designList[ind]["fbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["ftot"] * this.wodata.wo_full_cons);
    this.designList[ind]["hbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["htot"] * this.wodata.wo_half_cons);
    this.designList[ind]["balmtrs"] = nan(
      this.designList[ind]["fbalmtrs"] +
      this.designList[ind]["hbalmtrs"] -
      this.designList[ind]["mtr"]
    ).toFixed(2);

    this.calcTotal();
  }

  calcTotal() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      fs_tot = 0,
      hs_tot = 0,
      fh36_tot = 0,
      fh38_tot = 0,
      fh40_tot = 0,
      fh42_tot = 0,
      fh44_tot = 0,
      fh46_tot = 0,
      tot_pcs = 0;
    for (let i = 0; i < this.designList.length; i++) {
      const li = this.designList[i];
      fs_tot +=
        nan(li["f36"]) +
        nan(li["f38"]) +
        nan(li["f40"]) +
        nan(li["f42"]) +
        nan(li["f44"]) +
        nan(li["f46"]);
      hs_tot +=
        nan(li["h36"]) +
        nan(li["h38"]) +
        nan(li["h40"]) +
        nan(li["h42"]) +
        nan(li["h44"]) +
        nan(li["h46"]);
      fh36_tot += nan(li["f36"]) + nan(li["h36"]);
      fh38_tot += nan(li["f38"]) + nan(li["h38"]);
      fh40_tot += nan(li["f40"]) + nan(li["h40"]);
      fh42_tot += nan(li["f42"]) + nan(li["h42"]);
      fh44_tot += nan(li["f44"]) + nan(li["h44"]);
      fh46_tot += nan(li["f46"]) + nan(li["h46"]);
      tot_pcs += nan(li["ftot"]) + nan(li["htot"]);
    }
    this.wodata.fs_total = fs_tot;
    this.wodata.hs_total = hs_tot;
    this.wodata.fh36_tot = fh36_tot;
    this.wodata.fh38_tot = fh38_tot;
    this.wodata.fh40_tot = fh40_tot;
    this.wodata.fh42_tot = fh42_tot;
    this.wodata.fh44_tot = fh44_tot;
    this.wodata.fh46_tot = fh46_tot;
    this.wodata.tot_pcs = tot_pcs;
  }

  oncheckemptyrow() {
    /*   if( this.wodata.totalrate == 0 ||  this.wodata.totalrate == undefined){
           swal("Make sure that all the details are given!");  
        } */
    if (
      this.wodata.shirt_design_no == undefined ||
      this.wodata.party_name == undefined
    ) {
      swal("Make sure that all the details are given!");
    } else {
      /*   else if(this.wodata.shirt_design_no){
              let design = this.designList;
              for(let i=0;i<design.length;i++){
                  if(design[i]['balmtrs']>this.wodata.wo_half_cons){
                      this.toasterService.pop({
                          bodyOutputType: 1,
                          type: 'error',
                          title: 'Balance the meter!'
                      });  
                  }
           }
          } */
      let design = this.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].shade != "") {
          desList.push(design[i]);
        }

        this.designList = desList;
        // debugger;
        if (this.mode == "Cancel") {
          this.onsaveOrderReturn();
        } else {
          this.onSaveOrder();
        }
      }
    }
  }
  close() {
    let tabObj = {
      action: "CloseTab",
      params: {},
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  onSaveOrder(): void {
    let params: any = Object.assign({}, this.wodata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.designList);
    params["matching_data"] = JSON.stringify(this.match_designList);
    params["wo_date"] = this.datePipe.transform(
      params["wo_date"],
      "yyyy-MM-dd"
    );
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Work Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      $("#save").prop("disabled", true);
      that.isLoading = true;
      that.woservice
        .saveOrder(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);

            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
  onsaveOrderReturn(): void {
    // debugger;
    let params: any = Object.assign({}, this.wodata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.designList);
    params["matching_data"] = JSON.stringify(this.match_designList);
    params["wo_date"] = this.datePipe.transform(
      params["wo_date"],
      "yyyy-MM-dd"
    );
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to return this Work Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, return it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.woservice
        .saveOrderReturn(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Cancel") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
}









// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/addEditWorkOrder.ts